import { Routes } from '@angular/router';

import { PageHomeComponent } from './page-home/page-home.component';
import { PageAboutComponent } from './page-about/page-about.component';
import { PageContactComponent } from './page-contact/page-contact.component';
import { PageGalleryComponent } from './page-gallery/page-gallery.component';
import { PageSpicesComponent } from './page-spices/page-spices.component';
import { PageForestComponent } from './page-forest/page-forest.component';
import { PageAgriculturalComponent } from './page-agricultural/page-agricultural.component';
import { PageOthersComponent } from './page-others/page-others.component';

import { ShipChandlingComponent } from './ship-chandling/ship-chandling.component';
import { CrewChangeComponent } from './crew-change/crew-change.component';
import { HydrographicSurveyComponent } from './hydrographic-survey/hydrographic-survey.component';
import { MarineWorksComponent } from './marine-works/marine-works.component';
import { PilotageAndMooringComponent } from './pilotage-and-mooring/pilotage-and-mooring.component';

import { MaritimeClaimsComponent } from './maritime-claims/maritime-claims.component';
import { MarineInsuranceComponent } from './marine-insurance/marine-insurance.component';
import { ArbitrationMediationComponent } from './arbitration-mediation/arbitration-mediation.component';
import { LegalConsultationsComponent } from './legal-consultations/legal-consultations.component';

const company = 'SHINGAD SHIPPING LINES PRIVATE LIMITED';

export const routes: Routes = [
    {
        path: '',
        component: PageHomeComponent,
        title: `Home | ${company}`
    },
    {
        path: 'about',
        component: PageAboutComponent,
        title: `About Us | ${company}`
    },
    {
        path: 'contact',
        component: PageContactComponent,
        title: `Contact Us | ${company}`
    },
    {
        path: 'gallery',
        component: PageGalleryComponent,
        title: `Gallery | ${company}`
    },

    // Products
    {
        path: 'spices-products',
        component: PageSpicesComponent,
        title: `Spices Products | ${company}`
    },
    {
        path: 'forest-products',
        component: PageForestComponent,
        title: `Forest Products | ${company}`
    },
    {
        path: 'agricultural-products',
        component: PageAgriculturalComponent,
        title: `Agricultural Products | ${company}`
    },
    {
        path: 'other-products',
        component: PageOthersComponent,
        title: `Other Products | ${company}`
    },

    // Shipping and Maritime Operations
    {
        path: 'ship-chandling-division',
        component: ShipChandlingComponent,
        title: `Ship Chandling Services | ${company}`
    },
    {
        path: 'crew-change-services',
        component: CrewChangeComponent,
        title: `Crew Change Services | ${company}`
    },
    {
        path: 'hydrographic-survey-services',
        component: HydrographicSurveyComponent,
        title: `Hydrographic Survey Services | ${company}`
    },
    {
        path: 'marine-works-and-dredging-services',
        component: MarineWorksComponent,
        title: `Marine Works and Dredging Services | ${company}`
    },
    {
        path: 'pilotage-and-mooring-operations',
        component: PilotageAndMooringComponent,
        title: `Pilotage and Mooring Operations | ${company}`
    },

    // Legal Services
    {
        path: 'maritime-claims',
        component: MaritimeClaimsComponent,
        title: `Maritime and Admiralty Claims | ${company}`
    },
    {
        path: 'marine-insurance',
        component: MarineInsuranceComponent,
        title: `Marine Insurance Claims | ${company}`
    },
    {
        path: 'arbitration-mediation',
        component: ArbitrationMediationComponent,
        title: `Maritime Arbitration and Mediation | ${company}`
    },
    {
        path: 'legal-consultations',
        component: LegalConsultationsComponent,
        title: `Maritime Legal Advice and Consultations | ${company}`
    },

    // Redirect unknown URLs to Home
    {
        path: '**',
        redirectTo: ''
    }
];